import React, { useState, useEffect, useContext } from "react";
import "./AdminLayout.css";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { API } from "../constants/Api";
import { toast } from "react-toastify";
import { ProfileUpdate } from "../App";
import { jwtDecode } from "jwt-decode";
function AdminLayout() {
  const token = localStorage.getItem("token");
  const adminId = localStorage.getItem("adminId");
  const adminEmail = localStorage.getItem("adminEmail");
  const adminName = localStorage.getItem("adminName");
  const adminPhone = localStorage.getItem("adminPhone");
  const adminRole = localStorage.getItem("adminRole");

  const [previewImage, setPreviewImage] = useState(null);
  const { profileUpdateState, setProfileUpdateState } =
    useContext(ProfileUpdate);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await fetch(
          `${API}/auth/admins/get-singleAdmin/${adminId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();

        if (response.ok) {
          setPreviewImage(json.imageUrl);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    getUserInfo();
  }, [profileUpdateState]);
  useEffect(() => {
    if (adminId) {
      const currentDate = new Date();

      if (token) {
        let decodedToken = jwtDecode(token);
        // Check if decodedToken is valid
        if (decodedToken && decodedToken.exp) {
          // Check if the token has expired
          if (decodedToken.exp * 1000 < currentDate.getTime()) {
            console.log("Token expired.");
            localStorage.removeItem("token");
            localStorage.removeItem("adminId");
            localStorage.removeItem("adminEmail");
            localStorage.removeItem("adminName");
            localStorage.removeItem("adminPhone");
            localStorage.removeItem("adminRole");

            navigate("/admin");
          }
        } else {
          console.error("Invalid token: decodedToken is missing or malformed");
        }
      }
    } else {
      navigate("/admin");
    }
  }, [token, location.pathname]);
  
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [name, setName] = useState("Anya Forger");
  const [zip, setZip] = useState("9000");
  const [image, setImage] = useState(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" &&
      window.matchMedia("(max-width: 768px)").matches
  );

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleChange = (event) => {
      setIsMobile(event.matches);
      if (!event.matches) setIsSidebarVisible(true);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const handleLogout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminId");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminPhone");

    navigate("/admin");
    // const data = {
    //   adminId: admintId,
    // };
    // const toastLoading = toast.loading("Logging out...");
    // try {
    //   const response = await fetch(`${API}/agents/logout-agent`, {
    //     method: "POST",
    //     body: JSON.stringify(data),
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    //   const json = await response.json();
    //   if (response.ok) {
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("agentId");
    //     localStorage.removeItem("agentEmail");
    //     localStorage.removeItem("agentName");
    //     localStorage.removeItem("agentPhone");
    //     localStorage.removeItem("agentZipCode");
    //     localStorage.removeItem("agentVendorType");

    //     toast.success(json.message);
    //     navigate("/agent-register");
    //   }
    // } catch (error) {
    // } finally {
    //   toast.dismiss(toastLoading);
    // }
  };
  useEffect(() => {
    setIsSidebarVisible(false);
  }, [location.pathname]);
  return (
    <div className="user-layout container-fluid pt-2 pb-4">
      <div className="row">
        <div
          className={`col-12 py-3 ${isMobile ? "" : "px-5"} user-layout-header d-flex align-items-center justify-content-between`}
        >
          <Link style={{ textDecoration: "none" }} to="/">
            <img
              src="/img/Logo.svg"
              className="img-fluid home-logo ms-2"
              alt="Logo"
            />
          </Link>

          {isMobile && (
            <button
              className="btn btn-outline-light"
              onClick={toggleSidebar}
              style={{
                color: "black",
                backgroundColor: "#D4BB99",
                border: "1px solid #d4bb98",
              }}
            >
              <i className="bi bi-list" />
            </button>
          )}
        </div>
      </div>
      <div className="row">
        {(!isMobile || isSidebarVisible) && (
          <div
            className={`${
              isMobile
                ? "col-12"
                : "col-md-4 col-lg-3 col-xl-3 col-xxl-2 py-3 ps-5"
            } user-layout-sidebar`}
          >
            <div className="verification-card py-0">
              <div className="verification-card-checks">
                <img src="/img/checked.svg" className="img-fluid" alt="" />
              </div>
              <h3 className="user-layout-verify-text">
                {adminRole === "superAdmin" &&
                adminEmail === "rickmuro@dealdirecthomes.com"
                  ? "Master Admin"
                  : ""}
                {adminRole === "superAdmin" &&
                adminEmail === "brittany@dealdirecthomes.com"
                  ? "Admin"
                  : ""}
                {adminRole === "admin" ? "Admin" : ""}
              </h3>
            </div>
            <div className="user-layout-sidebar-content">
              <ul className="user-layout-nav">
                <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/admin-auth/profile" ? "user-layout-nav-items-active" : ""}`}
                    to="/admin-auth/profile"
                  >
                    <img
                      src={`/img/profile-icon${location.pathname === "/admin-auth/profile" ? "-active" : ""}.svg`}
                      className="img-fluid"
                      alt=""
                    />
                    Profile
                  </Link>
                </li>
                {adminRole === "superAdmin" ? (
                  <>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/agent-status" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/agent-status"
                      >
                        <img
                          src={`/img/agent-status${location.pathname === "/admin-auth/agent-status" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Agent Status
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/adv-status" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/adv-status"
                      >
                        <img
                          src={`/img/agent-status${location.pathname === "/admin-auth/adv-status" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Advertisers
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/payments" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/payments"
                      >
                        <img
                          src={`/img/payment${location.pathname === "/admin-auth/payments" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Payments
                      </Link>
                    </li>
                    <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/admin-auth/admin-zips" || location.pathname === "/admin-auth/zip-detail" ? "user-layout-nav-items-active" : ""}`}
                    to="/admin-auth/admin-zips"
                  >
                    <i className="bi bi-globe-americas" style={{ width: "18px" }} />
                    Zip Codes
                  </Link>
                </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/all-users" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/all-users"
                      >
                        <img
                          src={`/img/profile-icon${location.pathname === "/admin-auth/all-users" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        All Users
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/all-houses" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/all-houses"
                      >
                        <img
                          src={`/img/tour-icon${location.pathname === "/admin-auth/all-houses" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Tour Leads
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/all-offers" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/all-offers"
                      >
                        <img
                          src={`/img/offer-icon${location.pathname === "/admin-auth/all-offers" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Offer Leads
                      </Link>
                    </li>
                    {adminEmail === "brittany@dealdirecthomes.com" ? (
                      <></>
                    ) : (
                      <>
                        {/* <li>
                          <Link
                            className={`user-layout-nav-items ${location.pathname === "/admin-auth/add-admin" ? "user-layout-nav-items-active" : ""}`}
                            to="/admin-auth/add-admin"
                          >
                            <img
                              src={`/img/add-admin-icon${location.pathname === "/admin-auth/add-admin" ? "-active" : ""}.svg`}
                              className="img-fluid"
                              alt=""
                            />
                            Add an Admin
                          </Link>
                        </li> */}
                        <li>
                          <Link
                            className={`user-layout-nav-items ${location.pathname === "/admin-auth/admin-chat" ? "user-layout-nav-items-active" : ""}`}
                            to="/admin-auth/admin-chat"
                          >
                            <img
                              src={`/img/chat-icon${location.pathname === "/admin-auth/admin-chat" ? "-active" : ""}.svg`}
                              className="img-fluid"
                              alt=""
                            />
                            Chat
                          </Link>
                        </li>
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}
                {adminRole === "admin" ? (
                  <>
                     <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/adv-status" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/adv-status"
                      >
                        <img
                          src={`/img/agent-status${location.pathname === "/admin-auth/adv-status" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Advertisers
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/admin-adv" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/admin-adv"
                      >
                        <img
                          src={`/img/advertisement${location.pathname === "/admin-auth/admin-adv" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Payments
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/admin-auth/sub-admin-chat" ? "user-layout-nav-items-active" : ""}`}
                        to="/admin-auth/sub-admin-chat"
                      >
                        <img
                          src={`/img/chat-icon${location.pathname === "/admin-auth/sub-admin-chat" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Chat
                      </Link>
                    </li>
                  </>
                ) : (
                  <></>
                )}
                <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/admin-auth/password" ? "user-layout-nav-items-active" : ""}`}
                    to="/admin-auth/password"
                  >
                    <i className="bi bi-key" style={{ width: "18px" }} />
                    Change Password
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/agent-auth/request" ? "user-layout-nav-items-active" : ""}`}
                    to="/agent-auth/request"
                  >
                    <img
                      src={`/img/tour-icon${location.pathname === "/agent-auth/request" ? "-active" : ""}.svg`}
                      className="img-fluid"
                      alt=""
                    />
                    Requests
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        )}

        {(!isMobile || !isSidebarVisible) && (
          <div
            className={`${
              isMobile
                ? "col-12"
                : "col-md-8 col-lg-9 col-xl-9 col-xxl-10 py-3 pe-5"
            } user-layout-content`}
          >
            <div className="container-fluid" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-12 user-layout-content-header">
                  <div className="user-layout-content-header-box">
                    <div className="user-layout-content-header-image">
                      {previewImage ? (
                        <img
                          src={previewImage}
                          className="user-layout-content-header-image-media"
                          alt=""
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="user-layout-content-header-details">
                      <h3
                        className="user-layout-content-header-details-name my-0"
                        style={{ textTransform: "capitalize" }}
                      >
                        {adminName}
                        <span className="badge rounded-pill ms-3 user-badge">
                          {adminRole === "superAdmin" &&
                          adminEmail === "rickmuro@dealdirecthomes.com"
                            ? "Super Admin"
                            : "Admin"}
                        </span>
                      </h3>
                    </div>
                  </div>
                  <button onClick={handleLogout} className="btn logout-button">
                    <i className="bi bi-power me-2" />
                    Logout
                  </button>
                </div>
              </div>
              {location.pathname.includes("chat") ? (
                <>
                  <div className="row" style={{ height: "100%" }}>
                    <div
                      className={`${isMobile ? "col-12 p-0" : "col-md-12 p-0"}`}
                    >
                      <div className="user-layout-page-content">
                        <Outlet />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row" style={{ height: "100%" }}>
                    <div
                      className={`${isMobile ? "col-12 p-0" : "col-md-9 p-0"}`}
                    >
                      <div className="user-layout-page-content">
                        <Outlet />
                      </div>
                    </div>
                    {isMobile ? (
                      <></>
                    ) : (
                      <div className="col-md-3 ps-3 pe-0">
                        <div className="user-layout-page-content">
                          remain static
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}{" "}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminLayout;
